<template>
    <div class="row justify-content-center">
        <span class="col-auto"><a href="https://www.instagram.com/ultimatejetvacations/" target="_blank" class="link-style-white"><i aria-hidden="true" class="fa fa-instagram align-middle"></i></a></span>
        <span class="col-auto"><a href="https://www.facebook.com/UltimateJetVacations/" target="_blank" class="link-style-white"><i aria-hidden="true" class="fa fa-facebook-square align-middle"></i></a></span>
        <span class="col-auto"><a href="https://twitter.com/UltimateJetVac" target="_blank" class="link-style-white"><i aria-hidden="true" class="fa fa-twitter align-middle"></i></a></span>
        <span class="col-auto"><a href="https://www.youtube.com/channel/UCCX0IpPdWuEyGVXpBiIiNKA/featured" target="_blank" class="link-style-white"><i aria-hidden="true" class="fa fa-youtube-play align-middle"></i></a></span>
    </div>
</template>

<script>
    export default {
        mounted() {

        }
    }
</script>

<style lang="scss" type="text/scss">
    /** Unique Index Styles **/
</style>